import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=b2b3032e&scoped=true"
import script from "./FaqList.vue?vue&type=script&lang=js"
export * from "./FaqList.vue?vue&type=script&lang=js"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=b2b3032e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b3032e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FaqStructuredData: require('/app/components/FaqStructuredData.vue').default})
